import { useOpenDashServices } from "..";
export function useUserService() {
    const { UserService } = useOpenDashServices();
    return UserService;
}
//# sourceMappingURL=useUserService.js.map